import { render, staticRenderFns } from "./ControlComponent.vue?vue&type=template&id=223d228e&"
import script from "./ControlComponent.vue?vue&type=script&lang=ts&"
export * from "./ControlComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports